import React from 'react';
import classNames from 'classnames';
import { imagePath } from '../../../../utils';
export const BackgroundPanel = ({ className, title, selectedIndex, backgrounds, onSelect, }) => {
    const newSelection = (index) => {
        if (index !== selectedIndex) {
            onSelect(index);
        }
    };
    return (React.createElement("div", { className: classNames(className, `backgrounds-panel`) },
        React.createElement("h3", { className: "backgrounds-panel_title" }, title),
        backgrounds.map(({ label, imageName, disabled = false }, index) => {
            return (React.createElement("div", { key: label, className: classNames(`backgrounds-panel_option`, {
                    'backgrounds-panel_option--selected': index === selectedIndex,
                    'backgrounds-panel_option--disabled': disabled,
                }) },
                React.createElement("div", { className: classNames(`backgrounds-panel_image`, {
                        disabled,
                    }), onClick: () => {
                        if (!disabled) {
                            newSelection(index);
                        }
                    } },
                    React.createElement("img", { src: imagePath(imageName) })),
                React.createElement("div", { className: classNames(`backgrounds-panel_label`, {
                        disabled,
                    }), onClick: () => {
                        if (!disabled) {
                            newSelection(index);
                        }
                    } },
                    React.createElement("span", null, label))));
        })));
};
//# sourceMappingURL=BackgroundPanel.js.map